import { comments } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-2">
            吃瓜群众热议
          </h2>
          <p className="text-sm text-foreground-500">看看大家对最新爆料的精彩评论</p>
        </div>
        <div className="max-w-[800px] mx-auto space-y-4 md:space-y-5">
          {comments.map((item) => (
            <div
              key={item.id}
              className="flex gap-3 md:gap-4 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/60 cursor-pointer hover:border-accent-200/60 transition-all duration-300"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                <img
                  src={item.avatar}
                  alt={item.nickname}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                  <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">
                    {item.nickname}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-2">{item.content}</p>
                <div className="flex items-center gap-4">
                  <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-accent-500 transition-colors cursor-pointer">
                    <i className="ri-thumb-up-line"></i>
                    <span>{item.likes.toLocaleString()}</span>
                  </button>
                  <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                    <i className="ri-chat-1-line"></i>
                    <span>回复</span>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}